import { useEffect, useState } from 'react'

const QUERY = '(prefers-reduced-motion: reduce)'

function prefersReduced(): boolean {
  return (
    typeof window !== 'undefined' &&
    typeof window.matchMedia === 'function' &&
    window.matchMedia(QUERY).matches
  )
}

/**
 * Reduced motion is active when the OS-level prefers-reduced-motion
 * preference is set OR when the in-app accessibility setting is enabled.
 */
export function useReducedMotion(inAppReducedMotion: boolean): boolean {
  const [osPreference, setOsPreference] = useState<boolean>(prefersReduced)

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return
    const media = window.matchMedia(QUERY)
    const onChange = (event: MediaQueryListEvent) => setOsPreference(event.matches)
    setOsPreference(media.matches)
    media.addEventListener('change', onChange)
    return () => media.removeEventListener('change', onChange)
  }, [])

  return osPreference || inAppReducedMotion
}
